<template>
  <div class="sku-item">
    <el-tag type="warning" v-if="!(isReadOnly || unEditSku)">提示：在输入框中输入不存在的规格或规格值后回车，即可添加自定义规格或规格值。</el-tag>
    <el-tag type="warning" v-if="!isReadOnly && unEditSku">商品已入库，不可新增或减少规格</el-tag>
    <el-form class="sku-item-form" ref="skuFormRef" :model="skuForm" :disabled="(isReadOnly || unEditSku)"
      @submit.native.prevent label-width="80px">
      <div v-for="(item, index) in skuForm.skuInfo" :key="index">
        <el-form-item class="sku-form-name" label="规格名：" :prop="`skuInfo.${index}.${format.skuAttrId}`"
          :rules="[{ required: true, message: '请选择规格名', trigger: 'change' }]">
          <div class="sku-form-name-box">
            <el-select v-model="skuForm.skuInfo[index][format.skuAttrId]" clearable ref="skuAttr" filterable
              placeholder="请选择规格名" @change="handleSkuAttrNameChange(item[format.skuAttrId], index)"
              @keyup.enter.native="handleSkuAttrNameEnter($event, index)">
              <div class="select-list" v-for="skuItem in skuList" :key="skuItem[format.skuAttrId]">
                <el-option :disabled="judgeDisabledSkuAttrName(
                  skuForm.skuInfo[index][format.skuAttrId],
                  skuForm.skuInfo,
                  skuItem[format.skuAttrId]
                )
                  " :label="skuItem[format.skuAttrName]" :value="skuItem[format.skuAttrId]"></el-option>
                <!-- <i class="del-sku-name el-icon-delete"></i> -->
              </div>
            </el-select>
            <el-button v-show="!(isReadOnly || unEditSku)" :disabled="skuForm.skuInfo.length <= 1" class="delete-name"
              type="danger" size="mini" icon="el-icon-delete" @click="handleCloseSkuItem(index)">删除</el-button>
          </div>
        </el-form-item>

        <el-form-item class="sku-form-value" label="规格值：" :prop="`skuInfo.${index}.${format.skuValueList}`"
          :rules="[{ validator: validatorSkuList, trigger: 'change' }]">
          <el-select :ref="index + 'skuValue'" class="sku-value-select"
            v-for="(skuValueItem, valueIndex) in item[format.skuValueList]" :key="valueIndex" clearable
            v-model="skuForm.skuInfo[index][format.skuValueList][valueIndex][format.skuValueId]" filterable
            placeholder="请选择规格值" @change="handleSkuValueChange(item, skuValueItem[format.skuValueId], valueIndex)"
            @keyup.enter.native="handleSkuValueEnter($event, item, valueIndex, index)">
            <div class="select-list" v-for="valueItem in getSkuValueList(item)" :key="valueItem[format.skuValueId]">
              <el-option :disabled="judgeDisabledSkuValue(
                skuValueItem[format.skuValueId],
                item[format.skuValueList],
                valueItem[format.skuValueId]
              )
                " :label="valueItem[format.skuValue]" :value="valueItem[format.skuValueId]"></el-option>
              <!-- <i class="del-sku-name el-icon-delete"></i> -->
            </div>
            <template slot="prefix">
              <el-button v-show="!(isReadOnly || unEditSku)" :disabled="item[format.skuValueList].length <= 1"
                class="del-button" size="mini" icon="el-icon-delete"
                @click.stop="handleCloseSkuValue(index, valueIndex)"></el-button>

            </template>
          </el-select>
          <el-button v-show="!(isReadOnly || unEditSku)" type="text" size="mini" class="add-btn-skuval"
            @click="addSkuValue(index, item)">添加规格值</el-button>
        </el-form-item>
      </div>
    </el-form>
    <div v-show="!(isReadOnly || unEditSku)" class="add-sku" @click="addSkuItem">+ 配置新的规格项目</div>
  </div>
</template>
<script>
import { goodsApi } from "@/api"
export default {
  props: {
    categoryId: {
      default: null
    },
    format: {
      type: Object,
      default: () => {
        return { // 字段属性
          skuAttrId: "skuAttrId",
          skuAttrName: "skuAttrName",
          skuValueList: "skuValueList",
          skuValue: "skuValue",
          skuValueId: "skuValueId"
        }
      }
    },
    skuInfo: {
      type: Array,
      default: () => {
        return []
      }
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    unEditSku: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validatorSkuList = (rule, value, callback) => {
      const hasSelectSKuValu = value.find(item => item[this.format.skuValueId] !== "")
      if (hasSelectSKuValu) {
        callback()
      } else {
        callback("请至少选择一个选择规格值")
      }
    }
    return {
      hasGet: false,
      validatorSkuList,
      skuForm: {
        skuInfo: []
      },
      skuList: [],
      config: {
        canDelSkuAttrName: true, //是否可以删除规格名
        canDelSkuValue: true, //是否可以删除规格值
        canAddSkuAttrName: true, //是否可以添加规格名
        canAddSkuValue: true //是否可以添加规格值
      }
    }
  },
  created() {
    // 生成一条规格项
    this.addSkuItem()
  },
  watch: {
    async categoryId(val) {
      if (val) {
        await this.getSKuList(val)
        if (this.skuInfo.length > 0) {
          this.hasGet = true
          this.skuForm.skuInfo = this.skuInfo
        } else {
          this.skuForm.skuInfo = [
            {
              [this.format.skuAttrId]: "",
              [this.format.skuAttrName]: "",
              [this.format.skuValueList]: []
            }
          ]
        }
        // 触发生成规格明细
        this.handleGenerateSkuTable()
      }
    }
  },
  methods: {
    // 校验规格填写
    validateSkuItem() {
      return new Promise(resolve => {
        this.$refs.skuFormRef.validate(valid => {
          resolve(valid)
        })
      })
    },
    // 生成规格表
    handleGenerateSkuTable() {
      //去除为空的选项
      const resultSkuInfo = this.formatSkuData(this.skuForm.skuInfo)
      //向外传递一个方法 更新skudata 数据
      this.$emit("generateSkuTable", resultSkuInfo)
    },
    // 格式化数据
    formatSkuData(skuInfo) {
      const copySkuInfo = JSON.parse(JSON.stringify(skuInfo))
      const arr = []
      for (let i = 0; i < copySkuInfo.length; i++) {
        const item = copySkuInfo[i]
        //过滤规格值列表数据
        item[this.format.skuValueList] = item[this.format.skuValueList].filter(valueItem => {
          return valueItem[this.format.skuValueId] !== ""
        })
        //如果规格名不为空 且规格值有数据  则返回
        if (item[this.format.skuAttrName] && item[this.format.skuValueList] && item[this.format.skuValueList].length) {
          arr.push(item)
        }
      }

      return arr
    },
    // 获取规格列表
    getSKuList(categoryId) {
      // 获取商品规格
      return goodsApi.getSkuAttrListByCategoryId({ categoryId }).then((data) => {
        this.skuList = data
      })
    },
    // 判断规格名称是否禁选
    judgeDisabledSkuAttrName(selectValue, list, labelValue) {
      const hadSelectList = list.map((item) => item[this.format.skuAttrId])
      return hadSelectList.includes(labelValue) && selectValue !== labelValue
    },
    /** 添加规格项 */
    addSkuItem() {
      this.$set(this.skuForm.skuInfo, this.skuForm.skuInfo.length, {
        [this.format.skuAttrId]: "",
        [this.format.skuAttrName]: "",
        [this.format.skuValueList]: []
      })
    },
    // 设置规格数据
    setSkuAttrItem($index, item) {
      this.$set(this.skuForm.skuInfo[$index], this.format.skuValueList, [])
      this.$set(
        this.skuForm.skuInfo[$index],
        this.format.skuAttrName,
        item && item[this.format.skuAttrName]
      )
      this.$set(
        this.skuForm.skuInfo[$index],
        this.format.skuAttrId,
        item && item[this.format.skuAttrId]
      )
      // 触发生成规格明细
      this.handleGenerateSkuTable()
    },
    // 规格名变化事件
    handleSkuAttrNameChange(skuAttrId, $index, item) {
      //如果规格名为空
      if (!skuAttrId) {
        // //设置值为空并通知外部sku值变化
        this.setSkuAttrItem($index, {
          [this.format.skuAttrName]: "",
          [this.format.skuAttrId]: ""
        })
        return
      }
      // 检测当前规格项是否已经存在且不止一次
      const _skuInfo = this.skuForm.skuInfo.filter((key, index) => {
        //排除本身
        if (index === $index) {
          return false
        }
        return key[this.format.skuAttrId] === skuAttrId
      })

      if (_skuInfo.length > 0) {
        //清除选项值
        this.$set(this.skuForm.skuInfo[$index], [this.format.skuAttrId], "")
        this.$modal.msgWarning("当前规格项已存在，请重新选择或者编辑！")
      } else {
        if (item) {
          //如果有传 规格对象过来 直接设置
          this.setSkuAttrItem($index, item)
          // 选择完规格名称 顺带创建一条规格值
          this.addSkuValue($index, item)
        } else {
          //用规格名换规格对象
          const _items = this.skuList.find((key) => {
            return key[this.format.skuAttrId] === skuAttrId
          })
          this.setSkuAttrItem($index, _items)
          // 选择完规格名称 顺带创建一条规格值
          this.addSkuValue($index, _items)
        }
      }
    },
    // 规格名回车事件
    handleSkuAttrNameEnter($event, index) {
      const skuAttrName = $event.target.value.replaceAll(" ", "") || ""
      if (!skuAttrName) { return }
      //用规格名换规格对象
      const skuAttrItem = this.skuList.find((item) => {
        return item[this.format.skuAttrName] === skuAttrName
      })
      //如果是已有的 直接调用change事件
      if (skuAttrItem) {
        this.handleSkuAttrNameChange(
          skuAttrItem[this.format.skuAttrId],
          index,
          skuAttrItem
        )
        this.$refs.skuAttr[index].blur()
      } else {
        //没有的 则 触发 新增
        //不让添加规格名
        if (!this.config.canAddSkuAttrName) {
          return
        }

        this.$modal
          .confirm(`新增规格名【${skuAttrName}】, 是否继续?`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            // 阻止回车事件弹开的弹框会默认确认的问题 当遇到回车键触发的 显示 elment的 confirm弹框时，可能会直接触发确认，导致用户无法点击取消该事件
            beforeClose(action, instance, done) {
              if (action === "confirm") {
                instance.$refs["confirm"].$el.onclick = a()
                const a = function(e) {
                  e = e || window.event
                  if (e.detail !== 0) {
                    done()
                  }
                }
              } else {
                done()
              }
            }
          })
          .then(() => {
            // 调用 通过规格名称 与 分类id 创建规格名 接口
            goodsApi.addSkuAttrByCategoryId({ categoryId: this.categoryId, skuAttrName }).then(data => {
              this.getSKuList(this.categoryId)
              //如果有传 规格对象过来 直接设置
              this.setSkuAttrItem(index, data)
              // 选择完规格名称 顺带创建一条规格值
              this.addSkuValue(index, data)
              this.$refs.skuAttr[index].blur()
            }).catch(err => {
              this.$refs.skuAttr[index].blur()
            })
          })
          .catch(() => {
            this.$refs.skuAttr[index].blur()
          })
      }
    },
    // 删除规格名
    handleCloseSkuItem($index) {
      this.skuForm.skuInfo.splice($index, 1)
      // 触发生成规格明细
      this.handleGenerateSkuTable()
    },
    // 获取规格值列表
    getSkuValueList(item) {
      const target = this.skuList.find((skuitem) => {
        return skuitem[this.format.skuAttrId] === item[this.format.skuAttrId]
      })
      return target[this.format.skuValueList]
    },
    /** 添加当前规格项的规格值*/
    addSkuValue(index, item) {
      if (this.skuForm.skuInfo[index][this.format.skuAttrName] === "") {
        this.$modal.msgWarning("规格名不能为空")
        return
      }
      if (
        !this.skuForm.skuInfo[index] ||
        !this.skuForm.skuInfo[index][this.format.skuAttrId] ||
        !this.skuForm.skuInfo[index][this.format.skuValueList]
      ) {
        this.$modal.msgWarning("请选择规格名")
        return
      }
      this.$set(
        this.skuForm.skuInfo[index][this.format.skuValueList],
        this.skuForm.skuInfo[index][this.format.skuValueList].length,
        {
          [this.format.skuAttrId]: item[this.format.skuAttrId],
          [this.format.skuAttrName]: item[this.format.skuAttrName],
          [this.format.skuValue]: "",
          [this.format.skuValueId]: ""
        }
      )
    },

    // 判断规格值是否禁选
    judgeDisabledSkuValue(selectValue, list, labelValue) {
      const hadSelectList = list.map((item) => item[this.format.skuValueId])
      return hadSelectList.includes(labelValue) && selectValue !== labelValue
    },
    // 删除规格值
    handleCloseSkuValue($index, index) {
      this.skuForm.skuInfo[$index][this.format.skuValueList].splice(index, 1)
      // 触发生成规格明细
      this.handleGenerateSkuTable()
    },
    // 规格值改变事件
    handleSkuValueChange(skuAttrItem, skuValueId, $index, item) {
      //如果规格值为空
      if (!skuValueId) {
        //通知外部sku值变化
        this.setSkuValueItem(skuAttrItem[this.format.skuValueList], $index, {
          [this.format.skuAttrName]: "",
          [this.format.skuAttrId]: "",
          [this.format.skuValueId]: "",
          [this.format.skuValue]: ""
        })
        return
      }
      // 检测当前规格项是否已经存在且不止一次
      const _skuInfo = skuAttrItem[this.format.skuValueList].filter((key, index) => {
        //排除本身
        if (index === $index) { return false }
        return key[this.format.skuValueId] === skuValueId
      })

      if (_skuInfo.length > 0) {
        //清除选项值
        this.$set(skuAttrItem[this.format.skuValueList][$index], [this.format.skuValueId], "")
        this.$modal.msgWarning("当前规格值已存在，请重新选择或者编辑！")
      } else {
        if (item) { //如果有传 规格对象过来 直接设置
          this.setSkuValueItem(skuAttrItem[this.format.skuValueList], $index, item)
        } else {
          //用规格名换规格对象
          const _items = this.getSkuValueList(skuAttrItem).find(key => {
            return key[this.format.skuValueId] === skuValueId
          })
          this.setSkuValueItem(skuAttrItem[this.format.skuValueList], $index, _items)
        }
      }
    },
    // 设置规格值
    setSkuValueItem(valueList, index, item) {
      this.$set(valueList[index], this.format.skuAttrName, item && item[this.format.skuAttrName])
      this.$set(valueList[index], this.format.skuAttrId, item && item[this.format.skuAttrId])
      this.$set(valueList[index], this.format.skuValue, item && item[this.format.skuValue])
      this.$set(valueList[index], this.format.skuValueId, item && item[this.format.skuValueId])
      // 触发生成规格明细
      this.handleGenerateSkuTable()
    },

    // 规格值回车事件
    handleSkuValueEnter($event, skuAttrItem, valueIndex, $index) {
      const skuValue = $event.target.value.replaceAll(" ", "") || ""
      if (!skuValue) { return }
      //用规格名换规格对象
      const _items = this.getSkuValueList(skuAttrItem).find(key => {
        return key[this.format.skuValue] === skuValue
      })
      //如果是已有的 直接调用change事件
      if (_items) {
        this.handleSkuValueChange(skuAttrItem, _items[this.format.skuValueId], valueIndex, _items)
        this.$refs[$index + "skuValue"][valueIndex].blur()
      } else { //没有的 则 触发 新增
        //不让添加规格名
        if (!this.config.canAddSkuValue) { return }
        this.$modal.confirm(`在规格名【${skuAttrItem[this.format.skuAttrName]}】下新增规格值【${skuValue}】, 是否继续?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          beforeClose(action, instance, done) {
            if (action === "confirm") {
              instance.$refs["confirm"].$el.onclick = a()
              const a = function(e) {
                e = e || window.event
                if (e.detail !== 0) {
                  done()
                }
              }
            } else {
              done()
            }
          }
        }).then(() => {
          this.$nextTick(() => {
            // 调用 通过规格名称 与 分类id 创建规格名 接口
            goodsApi.addSkuValueBySkuAttrId({ skuAttrId: skuAttrItem.skuAttrId, skuValue }).then(data => {
              this.getSKuList(this.categoryId)
              const item = {
                [this.format.skuAttrName]: data.skuAttrName,
                [this.format.skuAttrId]: data.skuAttrId,
                [this.format.skuValueId]: data.skuValueId,
                [this.format.skuValue]: data.skuValue
              }
              this.setSkuValueItem(skuAttrItem[this.format.skuValueList], valueIndex, item)
              this.$refs[$index + "skuValue"][valueIndex].blur()
            }).catch(err => {
              this.$refs[$index + "skuValue"][valueIndex].blur()
            })

          })
        }).catch(() => {
          this.$nextTick(() => {
            this.$refs[$index + "skuValue"][valueIndex].blur()
          })
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.select-list {
  width: 100%;
  line-height: 34px;
  position: relative;
  box-sizing: border-box;

  .del-sku-name {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }

  .el-select-dropdown__item[style="display: none;"]+.del-sku-name {
    display: none;
  }
}

.sku-item {
  width: 100%;
  border: 1px solid #e6ebf5;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;

  //添加sku项按钮
  .add-sku {
    border: 1px dashed #b3d8ff;
    color: #409eff;
    background: #ecf5ff;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
  }

  .btn-box {
    margin-top: 12px;
  }

  .sku-item-form {
    .sku-form-name {
      background: #f8f8f8;
      padding: 24px 12px;

      .sku-form-name-box {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .el-select {
          width: 218px;
        }
      }
    }

    .sku-form-value {
      padding: 12px;

      ::v-deep .el-form-item__error {
        top: calc(100% - 12px)
      }

      ::v-deep .sku-value-select {
        margin-right: 12px;
        margin-bottom: 12px;
        width: 218px;

        .el-input {
          .el-input__inner {
            padding-left: 15px;
            padding-right: 72px;
          }

          .el-input__prefix {
            position: absolute;
            left: unset;
            right: 1px;
            top: 1px;
            bottom: 1px;
            height: calc(100% - 2px);
            width: fit-content;

            .del-button {
              position: absolute;
              top: 1px;
              right: 0;
              border: none;
              height: calc(100% - 1px);
              background: #f5f7fa;

              &::after {
                content: "";
                width: 1px;
                height: calc(100% + 1px);
                background: #dcdfe6;
                position: absolute;
                top: 0;
                left: 0;
              }
            }
          }

          .el-input__suffix {
            right: 50px;
          }
        }
      }
    }
  }
}
</style>
